interface DirectSignState {
  username: string
  password: string
  mabIdentInProgress: boolean
  signatureState: string // TODO: Should be more narrow
  invitingBusinessId: string
}

export const useDirectSignStore = defineStore('directSign', {
  state: (): DirectSignState => ({
    username: '',
    password: '',
    mabIdentInProgress: false,
    signatureState: 'OPEN', // Default state for signature
    invitingBusinessId: '',
  }),
  getters: {
    auth(): { username: string; password: string } {
      if (this.username && this.password) return { username: this.username, password: this.password }
      return { username: '', password: '' }
    },
    authToken(): string {
      const { username, password } = this.auth
      if (username && password) {
        return btoa(`${username}:${password}`)
      }
      return ''
    },
    /**
     * @deprecated Use the more aptly named and built `authToken` getter instead.
     */
    directSignB64AuthHeader(): string {
      let str = ''
      const { username, password } = this.auth
      if (username && password) {
        str = btoa(`${username}:${password}`)
      }
      return str
    },
    directSignSession(): DirectSignSession | null {
      return this.auth.username ? { auth: this.auth } : null
    },
    isDirectSign(): boolean {
      return Boolean(this.directSignSession)
    },
    immutableEidFields(): string[] {
      const userStore = useUserStore()

      const fields = userStore.attributes.immutableEidFields

      return fields?.length ? fields : ['all']
    },
    isMabIdentInProgress(): boolean {
      return this.mabIdentInProgress
    },
    signIdentity() {
      const userStore = useUserStore()

      let identity = `${userStore.firstName ?? ''} ${userStore.lastName ?? ''}`.trim()

      if (!identity) {
        identity = userStore.signerIdentityEmail || ''
      }

      return identity
    },
  },
  actions: {
    setDirectSign(username: string, password: string) {
      this.username = username
      this.password = password
    },
    clearDirectSignSession(): void {
      this.username = ''
      this.password = ''
    },
    // TODO: Combine with user store
    async update(data: DirectUserUpdateData): Promise<void> {
      const userStore = useUserStore()
      const { directUserRepository } = useLegacyApi()

      await directUserRepository.update(data)
      await userStore.fetchUser()
    },
    async fetchSignatureStatusUntilSuccess(signatureRequestId: string, signatureId: string, signal?: AbortSignal) {
      if (this.mabIdentInProgress) return false
      this.mabIdentInProgress = true
      const { directSrRepository } = useLegacyApi()

      while (this.mabIdentInProgress && !signal?.aborted) {
        const signatureStatus = await directSrRepository.getSignatureStatus(signatureRequestId, signatureId, signal)
        this.signatureState = signatureStatus

        if (signatureStatus === 'OPEN') {
          await new Promise(resolve => setTimeout(resolve, 5000))
        } else {
          this.mabIdentInProgress = false
          return true
        }
      }
      return false
    },
    async checkCanJoinStarterPlan(businessId: string, srQuality: string, srId: string) {
      const { directUserRepository } = useLegacyApi()
      return directUserRepository.canJoinStarterPlan(businessId, srQuality, srId)
    },
  },
})
